import React, { Component } from 'react';
import { Col, Container, Row, Button, ButtonGroup, ButtonToolbar, Card, CardBody, Progress, Table} from 'reactstrap';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import moment from 'moment';

import Panel from '../../../shared/components/Panel';
import { Link } from "react-router-dom";

import { _getRefinaceClosedSales, _getRate, _getTract } from './apicalls';
import SubFilter from './SubFilter';
import GeneralBuildingSearchBar from "../../../shared/components/building_filters/GeneralBuildingSearchBar";
import {searchBarStyles} from '../../../shared/helpers/utils';
import ToggleChips from './ToggleChips';

import { 
	_lendingFilters	
} from "./filters";

const colors = {
	Low: '#ff4861',
	Moderate: '#f6da6e',
    Middle: '#70bbfd',
    Upper: '#4ce1b6',
};

const propertyOwnerLists = [
  { key: 0, label: "Long-Time Owners" },
  { key: 1, label: "Expired Listings (Didn't Sell)" },
  { key: 15, label: "Expiring Tax Abatements (421a, J51)" },
  { key: 14, label: "Co-ops Facing Fee Increases" },
  
  { key: 18, label: "Property Tax Increases" },
  { key: 6, label: "Inherited Property" },
  { key: 11, label: "Highly Appreciated Properties" },
  { key: 7, label: "Facing Tax Liens" },
  { key: 8, label: "Foreclosures" },
  { key: 17, label: "Properties with Open Violations" },
  { key: 16, label: "Changing Zoning Areas" }
];

class RefinanceClosings extends Component {
  static propTypes = {
    t: PropTypes.func.isRequired,
  };
 
  
  constructor() {
    super();
    this.state = {
      data: false,
      type: 'all',
      checkAll: false
    };
  }

  
  componentDidMount() {
	  
	const { type } = this.props;
	_getRefinaceClosedSales('lender:(*first*republic* *wells* *webster* *depot* *citi* *td* *jp*)', type, { callback: (result) => { 
		this.setState({ data: result.docs.filter(item => !(['condo', 'coop'].indexOf(item.ownership_type) >= 0 && item.address_2_normalized === '')) });
	} });
  }
  
  shouldComponentUpdate(nextProps, nextState) {
	  
	  const { type } = this.props;
	  return type !== nextProps.type || JSON.stringify(this.state.data) !== JSON.stringify(nextState.data);
  }
  
  componentDidUpdate() {
	const { type } = this.props;
	_getRefinaceClosedSales('lender:(*first*republic* *wells* *webster* *depot* *citi* *td* *jp*)', type, { callback: (result) => { 
		this.setState({ data: result.docs.filter(item => !(['condo', 'coop'].indexOf(item.ownership_type) >= 0 && item.address_2_normalized === '')) });
	} });
  }
  
   _formatBanks = (lender) => {
	  const banks = [
		 { name : 'First Republic', match: 'first' },
		 { name : 'Wells Fargo', match: 'wells' },
		 { name : 'Citizens', match: 'citizens' },
		 { name : 'TD Bank', match: 'td' },
		 { name : 'JP Morgan Chase', match: 'jp' },
	  ];
	  
	  let lenderName = lender.toString().split(',')[0].toString().replace('n.a.', '');
	  banks.map(bank => {
		  if(lenderName.indexOf(bank.match) >= 0) {
			  lenderName = bank.name;
		  }	
		  return null;	  
	   });
	   return lenderName; 
  }
  
  _formatBanks = (lender) => {
	  const banks = [
		 { name : 'First Republic', match: 'first' },
		 { name : 'Wells Fargo', match: 'wells' },
		 { name : 'Citizens', match: 'citizens' },
		 { name : 'TD Bank', match: 'td' },
		 { name : 'JP Morgan Chase', match: 'jp' },
	  ];
	  
	  let lenderName = lender.toString().split(',')[0].toString().replace('n.a.', '');
	  banks.map(bank => {
		  if(lenderName.indexOf(bank.match) >= 0) {
			  lenderName = bank.name;
		  }	
		  return null;	  
	   });
	   return lenderName; 
  }
  _toggle = (source) => {
	  let checkboxes = document.getElementsByName('add');
	  for(var i=0, n=checkboxes.length;i<n;i++) {
	    checkboxes[i].checked = source.currentTarget.checked;
	  }
	}
	
  render() {
      const { t, title, subhead } = this.props;
      
      const { data, type} = this.state;
      
      
      if (!data) return null;
	
	  return (
		  <Panel 
		  	lg={12} 
		  	xl={12} 
		  	md={12} 
		  	title={title}
			subhead={subhead}
		  >
		  	<GeneralBuildingSearchBar
				buildingFilter={
				  '(ownership_type:"condo" OR ownership_type:"condo-retail" OR building_status:"sponsor" OR ownership_type:"coop" OR ownership_type:"rental")'
				}
				handleSearch={null}
				buildingAttributes={[]}
				placeHolder={
				  "Search Owners by Neighborhood, Borough or Use the Map"
				}
				addBuilding={true}
				buildingTab={null}
				hideBoroHood={false}
				hideAddIcon={false}
				hideMapDraw={false}
				searchBarStyles={searchBarStyles}
			  
			  />
			  <ToggleChips chipData={propertyOwnerLists} />
		  	<SubFilter _filters={_lendingFilters} subFilters={{}} size={'xsmall'} />
		  	<div style={{textAlign:"right"}}>
		  		 <Button color="primary" type="submit" style={{fontSize:12,margin:"0px 0px 20px 0"}}>Create Owner List</Button>
		  		 
		  	</div>
		  	
		    <Table responsive striped className="table--bordered dashboard__audience-table">
		      <thead>
		        <tr>
		          <th style={{whiteSpace:'nowrap'}}><input type="checkbox" onClick={(e) => this._toggle(e)} /></th>
				  <th>Owner</th>
				  <th>Type</th>		          	          		          		          
				  <th>Address</th>	
				  <th>Ownership Length</th>
				  <th>Sold Price</th>
		          {/* <th>Lender</th>		          
		          <th>Area Income</th> */}
		         
		          <th>Est. Mortgage Rate</th>
		          	
		          	          
		          <th style={{ minWidth: 80 }}>% Financed</th>
		          
		        </tr>
		      </thead>
		      <tbody>
		       {data.map(row => 
                {
	               const censusTract = _getTract(row.borough_code, row.census_tract);
	               const color = censusTract && colors[censusTract.income] ? colors[censusTract.income] : '#CCC';

			       return (
				       <tr>
				       	  <td><input type="checkbox" name="add" /></td>
						  <td style={{ textTransform:'capitalize' }}>{row.owner.replace(', ', '- ').toString().split(',')[0].replace('- ', ', ')}</td>	 
						  <td style={{ textTransform:'capitalize' }}>{row.ownership_type.replace('-', ' ')}</td>
							   
							<td style={{ textTransform:'capitalize' }}> 
								<a href={`https://marketproof.com/linkto?building=${row.display_full_street_address},${row.borough}`}>
								{row.display_full_street_address}{row.address_2_normalized ? ', ' + row.address_2_normalized : ''}
								</a><br />
								<span style={{ fontSize:'11px' }}>{row.neighborhood[0]}, {row.borough}</span>
							</td>
							<td>{moment(row.close_date_formatted).fromNow()}</td>	
							<td className=""> 
								  <a href="javascript:(0)" onClick={() => row.document_ids.map(documentId => window.open(`https://a836-acris.nyc.gov/DS/DocumentSearch/DocumentImageView?doc_id=${documentId}`))}>
								  {['$', new Intl.NumberFormat('en').format(row.price)].join('')}</a> 
								  
								  {row.document_ids.length > 1 ? <p style={{ fontSize: '10px', marginTop:0 }}>{` (${row.document_ids.length} Loans)`}</p> : ''}
							  </td>
				       	  {/* <td style={{ textTransform:'capitalize' }}>
					       	  {this._formatBanks(row.lender[0])} 
				       	  </td>		
				       	  <td style={{ minWidth:'100px' }}>
				          	<span style={{ width:'10px', height:'10px', borderRadius:'50%', display:'inline-block', background:color, marginRight: '10px', }} />
				          	{censusTract.income || 'Unknown'}
				          </td> */}
				       	  
				       	  		         
				          
				       	  <td>{_getRate(moment(row.close_date_formatted).format('YYYY-MM-DD'))}%</td>			       	  
				          
				       	  
				          
				          <td>
				            <div className="progress-wrap">
				              <span>{row.percent_financed.toFixed(0)}%</span>
				              <Progress value={row.percent_financed} />
				            </div>
				          </td>
				         
				        </tr>
						); 
                }) 
		       }
		      </tbody>
		    </Table>
		    <Link to={`/`} className="see-more">See More &raquo;</Link>
		  </Panel>
		  );
	}
}

export default connect(state => ({
  rtl: state.rtl,
  theme: state.theme,
}))(withTranslation('common')(RefinanceClosings));
